const C = {
  name: "RefreshSmall",
  dimensions: { width: 14, height: 14 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2 7C2 4.26998 4.29499 2 7.18026 2C8.88305 2 10.3859 2.7921 11.3226 4H9C8.44771 4 8 4.44772 8 5C8 5.55228 8.44771 6 9 6H12.9768C13.0411 6.00151 13.1062 5.99678 13.1711 5.98542C13.2873 5.96538 13.3966 5.92529 13.4954 5.86885C13.6259 5.79464 13.7349 5.69361 13.8179 5.57552C13.9004 5.45846 13.9584 5.3229 13.9845 5.17628C13.9963 5.11095 14.0016 5.04411 14 4.97668V1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1V1.81156C10.723 0.682867 9.02717 0 7.18026 0C3.24664 0 0 3.11002 0 7C0 10.89 3.24664 14 7.18026 14C10.2849 14 12.9627 12.0704 13.9415 9.33712C14.1276 8.81717 13.8571 8.24473 13.3371 8.05854C12.8172 7.87235 12.2447 8.14292 12.0585 8.66288C11.3686 10.5896 9.45243 12 7.18026 12C4.29499 12 2 9.73002 2 7Z" fill="currentColor"/>
  `
};
export {
  C as RefreshSmall
};
